<div class="mt-6"></div>
<div *ngIf="(sentTo?.length ?? 0) == 0 && captcha">
  <h1 class="title is-5 mb-0">Passwort vergessen</h1>
  <p class="mt-2 mb-4 is-size-7">Bitte hinterlegen Sie Ihre E-Mail-Adresse / Benutzernamen, um einen Link für die
    Zurücksetzung des Passwortes per E-Mail zu erhalten.</p>
</div>
<div>
  <iw-shared-form-error [apiError]="formHandler.getFormError()"></iw-shared-form-error>
  <div *ngIf="(sentTo?.length ?? 0) == 0">
    <iw-shared-captcha (isVerified)="setCaptcha($event)"></iw-shared-captcha>
    <div>
      <div *ngIf="captcha" class="is-block">
        <div class="field" [formGroup]="form">
          <div class="control has-icons-left has-icons-right">
            <input class="input" type="text" formControlName="username" placeholder="E-Mail-Adresse / Benutzername"
                   value="">
            <span class="icon is-small is-left"><fa-icon [icon]="faUser"></fa-icon></span>
          </div>
          <p class="help is-danger" *ngIf="isFormKeyInvalid('username')">Bitte hinterlegen Sie ein Passwort.</p>
          <p class="help is-danger" *ngIf="errorMessage">{{errorMessage}}</p>
        </div>
        <iw-shared-form-submit-button [formStatus]="formHandler.getFormStatus()" submitLabel="Link zusenden"
                                      (submit)="submit()"></iw-shared-form-submit-button>
      </div>


    </div>
  </div>
</div>
<div *ngIf="sentTo">
  <p>Eine E-Mail zur Zurücksetzung des Passwortes wurde erfolgreich an {{ sentTo }} gesendet.
  </p>
</div>
